import { CurrencyTokenType as r, CurrencyTokenAssetName as a } from "../../constants/currency.js";
import * as e from "yup";
const n = e.mixed().oneOf(Object.values(r)).default(r.Unspecified), s = e.mixed().oneOf(Object.values(r)).default(r.Unspecified), o = e.mixed().oneOf(Object.values(a)).default(a.Unspecify), m = e.mixed().oneOf([...Object.values(r), null]).nullable().default(null), t = e.object({
  address: e.string().default("0x0"),
  amount: e.string().nullable().default("0"),
  assetName: e.string().default(""),
  decimals: e.number().default(0),
  image: e.string().default(""),
  imageLite: e.string().default(""),
  name: e.string().default(""),
  type: n
}).from("rewardTokenAddress", "address"), u = e.object({
  amount: e.string().default("0"),
  type: n
}), i = e.object({
  ratio: e.number().default(0),
  type: n.nullable(!1)
}).from("price", "ratio").from("currencyCode", "type").noUnknown(!0), d = t.from("currencyBalance", "amount").from("currencyCode", "type").noUnknown(!0), f = e.object({
  amount: e.string().nullable().default("0"),
  address: e.string().default("0x0"),
  assetName: e.string().default(""),
  decimals: e.number().default(0),
  image: e.string().default(""),
  imageLite: e.string().default(""),
  name: e.string().default(""),
  type: n
}).from("income", "amount").from("rewardInfo.decimal", "decimals").from("rewardInfo.rewardName", "assetName").from("rewardInfo.rewardTokenAddress", "address").from("rewardInfo.staticAssetKey.currency.image", "image").from("rewardInfo.staticAssetKey.currency.imageLite", "imageLite").from("rewardInfo.staticAssetKey.currency.name", "name").from("rewardInfo.staticAssetKey.currency.type", "type").noUnknown(!0), l = t.from("decimal", "decimals").from("rewardName", "assetName").from("staticAssetKey.currency.image", "image").from("staticAssetKey.currency.imageLite", "imageLite").from("staticAssetKey.currency.name", "name").from("staticAssetKey.currency.type", "type").noUnknown(!0);
export {
  l as currencyInfoSchema,
  f as currencyOffchainTokenSchema,
  o as currencyTokenAssetNameSchema,
  u as currencyTokenLiteSchema,
  d as currencyTokenRenamedSchema,
  t as currencyTokenSchema,
  s as currencyTokenTypeERC20Schema,
  m as currencyTokenTypeNullableSchema,
  n as currencyTokenTypeSchema,
  i as onChainTokenToUsdSchema
};
//# sourceMappingURL=currency.js.map
